import { environment } from '../../../../environments/environment';

export class SpsLogger {
  static isServer = typeof window === 'undefined';

  static log(message: string, stack: object = null): void {
    if (environment.production && !SpsLogger.isServer) {
      return;
    }

    console.log(message, stack);
  }

  static warn(message: string, stack: object = null): void {
    if (environment.production && !SpsLogger.isServer) {
      return;
    }

    console.warn(message, stack ?? '');
  }
}
